export default __webpack_public_path__ + "static/media/news15.bd776e2f.jpg";